import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {DialogButton} from '@mintdata-wsp/wsp/ui/components/forms/DialogButton';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ButtonStyle} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./ConfirmDialog.less');
const cx = classnames.bind(styles);

export enum ConfirmButtonSet
{
    YES_NO = 1,
    OK_CANCEL = 2,
    DISMISS_RELOAD = 3,
    DELETE_CANCEL = 4
}
export interface IConfirmDialogProps
{
    intent?:MDIntent;
    title:string;
    content?:string | JSX.Element;

    data?:any;
    buttonSet?:ConfirmButtonSet | string[];
    onConfirmed?:(data:any) => void | Promise<void>;
    onCancelled?:(data:any) => void | Promise<void>;
    isAlertMode?:boolean;
}


export interface IConfirmDialogState
{
    isLoading:boolean;
}

@observer
export class ConfirmDialog extends React.Component<IConfirmDialogProps, IConfirmDialogState>
{
    constructor(props:any)
    {
        super(props);

        this.state = {
            isLoading: false
        }
    }

    @bind
    _onConfirmed()
    {
        let {data, onConfirmed} = this.props;

        if( onConfirmed && typeof onConfirmed === 'function' )
        {
            this.setState({isLoading: true});

            const result = onConfirmed(data);
            
            if( result )
                result.then(() => this._hideDialog());
            else
                this._hideDialog();
        }
    }

    @bind
    _onCancelled()
    {
        let {data, onCancelled} = this.props;

        if( onCancelled && typeof onCancelled === 'function' )
        {
            const result = onCancelled(data);

            if( result )
                result.then(() => this._hideDialog());
            else
                this._hideDialog();
        }
    }

    @bind
    _hideDialog()
    {
        controllers.ui.dialogs.hideDialog(Dialogs.Confirm);
    }

    _renderButtonsRow()
    {
        let {
            buttonSet,
            intent = MDIntent.Default,
            isAlertMode = false,
        } = this.props;

        if( !buttonSet ) return null;

        let buttonTitles:string[];

        switch( buttonSet )
        {
            case ConfirmButtonSet.OK_CANCEL:
                buttonTitles = ['Cancel', 'OK'];
                break;
            case ConfirmButtonSet.YES_NO:
                buttonTitles = ['No', 'Yes'];
                break;
            case ConfirmButtonSet.DISMISS_RELOAD:
                buttonTitles = ['Dismiss', 'Reload page'];
                break;
            case ConfirmButtonSet.DELETE_CANCEL:
                buttonTitles = ['Cancel', 'DELETE'];
                break;
            default:
                buttonTitles = buttonSet;
        }

        return (
            <Row className={styles.buttonsRow}>
                {
                    (!isAlertMode && buttonTitles[0] !== null) &&
                    <DialogButton
                        caption={buttonTitles[0]}
                        intent={MDIntent.Default}
                        style={ButtonStyle.SimpleSecondary}
                        onClick={this._onCancelled}
                        className={styles.cancelBtn}
                    />
                }
                {buttonTitles[1] && <DialogButton
                    caption={buttonTitles[1]}
                    intent={intent}
                    onClick={this._onConfirmed}
                    isLoading={this.state.isLoading}
                />}
            </Row>
        );
    }

    render()
    {
        let {intent = MDIntent.Default, title, content} = this.props;

        const contentAsString = typeof content === 'string';

        return (
            <Dialog
                onEnterKey={this._onConfirmed}
                title={title}
                // titleIntent={intent}
                onClose={this._onCancelled}
            >
                <Column className={cx('contentColumn')}>
                    <div className={styles.content}>
                        {
                            (content && contentAsString) && <div>{content}</div>
                        }
                        {
                            (content && !contentAsString) && content
                        }
                    </div>
                    {this._renderButtonsRow()}

                </Column>
            </Dialog>
        );
    }
}
